export class Sale {
    value: Number = 0;
    measurement: String = "$";
    active: Boolean = false;
    tiers: String = 'all';
}



// WEBPACK FOOTER //
// ./src/app/sale.ts